'use strict';

exports.__esModule = true;

exports.default = function () {
  if (typeof window === 'undefined') return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var fragment = document.createDocumentFragment();
  var outer = document.createElement('div');
  outer.className = 'webmd-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  fragment.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;
  document.body.appendChild(fragment);

  return scrollBarWidth;
};

// import Vue from 'vue';

var scrollBarWidth = void 0;

;